<template>
  <div class="page-hero">
    <div class="page-hero-inner">
      <h1>{{ title }}</h1>
      <p>{{ subtitle }}</p>

      <!-- Contact Channels -->
      <div class="contact-channels">
        <div class="channel">
          <div class="channel-icon">
            <svg viewBox="0 0 24 24">
              <rect x="2" y="4" width="20" height="16" rx="1"></rect>
              <path d="M2 7l10 7 10-7"></path>
            </svg>
          </div>
          <div class="channel-body">
            <p class="channel-label">Email us</p>
            <p class="channel-title">
              <a
                href="mailto:support@hooliganseyewear.com"
                style="color: inherit; text-decoration: none"
                >support@hooliganseyewear.com</a
              >
            </p>
            <p class="channel-sub">
              We respond within 24 hours, Monday&ndash;Friday
            </p>
            <a :href="messageHref" class="channel-link">Send a message</a>
          </div>
        </div>
        <div class="channel">
          <div class="channel-icon">
            <svg viewBox="0 0 24 24">
              <path
                d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.12.9.33 1.78.62 2.63a2 2 0 0 1-.45 2.11L8 9.73a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.85.29 1.73.5 2.63.62A2 2 0 0 1 22 16.92z"
              ></path>
            </svg>
          </div>
          <div class="channel-body">
            <p class="channel-label">Call us</p>
            <p class="channel-title">
              <a :href="`tel:${business.phone}`">{{ business.phoneDisplay }}</a>
            </p>
            <p class="channel-sub">Customer support during business hours</p>
            <a :href="`tel:${business.phone}`" class="channel-link">Call now</a>
          </div>
        </div>
        <div class="channel">
          <div class="channel-icon">
            <svg viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="10"></circle>
              <path d="M12 6v6l4 2"></path>
            </svg>
          </div>
          <div class="channel-body">
            <p class="channel-label">Response time</p>
            <p class="channel-title">Within 24 hours</p>
            <p class="channel-sub">
              Monday&ndash;Friday, 9:00 AM&ndash;5:00 PM ET. Closed weekends.
            </p>
          </div>
        </div>
      </div>
      <address class="business-address">
        <strong>{{ business.legalName }}</strong>
        <span>{{ business.addressDisplay }}</span>
      </address>
    </div>
  </div>
</template>

<script>
import { BUSINESS } from "~/core/config/business";

export default {
  name: "CustomerCareHero",
  data() {
    return { business: BUSINESS };
  },
  props: {
    title: {
      type: String,
      default: "Customer Care",
    },
    subtitle: {
      type: String,
      default:
        "We’re here to help. Find answers, track your order, or get in touch with our team.",
    },
    messageHref: {
      type: String,
      default: "/contact#contact-form",
    },
  },
};
</script>
